<template>
  <div class="menu">
    <menu-tree
      :tree-data="navList"
      :default-active="defaultActive"
    />
  </div>
</template>

<script>
import { $dg_getNavList } from '@/api';
import MenuTree from '../../components/MenuTree';

export default {
  name: 'LeftNav',
  components: { MenuTree },
  data() {
    return {
      navList: [],
    };
  },
  computed: {
    // 获取默认选中的详情页面
    defaultActive() {
      const { navList } = this;
      if (!navList.length) return '';
      const { channelId, leafId, attrName } = this.$store.state.routeQuery;
      const chn = this.navList.find(v => v.id === +channelId);
      const leaf = chn.children.find(v => v.id === +leafId);
      if (attrName) {
        const attr = leaf.children.find(v => v.name === attrName);
        return `attr-${attr.id}`;
      }
      return `leaf-${leafId}`;
    },
  },
  watch: {
    $route({ query }) {
      const { channelId, leafId, attrName } = query;
      this.$store.commit('Storage_setQuery', { channelId, leafId, attrName });
      this.setRouteName({ channelId, leafId, attrName });
    },
  },
  methods: {
    // 获取导航
    setRouteName({ channelId, leafId = '', attrName = '' }) {
      const child = this.navList.find(v => v.id === +channelId);
      if (!channelId) return;
      if (!leafId) {
        this.$store.commit('Storage_setBread', [`${child.name}`]);
        return;
      }
      const leaf = child.children.find(v => v.id === +leafId);
      if (!attrName) {
        this.$store.commit('Storage_setBread', [`${child.name}`, `${leaf.name}`]);
      } else {
        const attr = leaf.children.find(v => v.name === attrName);
        this.$store.commit('Storage_setBread', [`${child.name}`, `${leaf.name}`, `${attr.name}`]);
      }
    },
    async getFirstNavList() {
      const resp = await $dg_getNavList();
      this.navList = resp || [];
      if (!resp) return;
      const query = this.parseQuery(resp);
      this.$store.commit('Storage_setQuery', query);
      this.setRouteName(query);
    },
    parseQuery(list) {
      const query = {};
      const queryArray = Object.entries(this.$route.query);
      if (!queryArray.length) this.setDefaultQuery(list, query);
      queryArray.forEach(([k, v]) => {
        if (k === 'chnid') query.channelId = v;
        if (k === 'leafid') query.leafId = v;
        if (k === 'attr') query.attrName = v;
        if (k === 'DocID') query.docId = v;
        query[k] = v;
      });
      return query;
    },
    setDefaultQuery(list, query) {
      if (!list[0]) return;
      const item = list[0];
      const type = item.type || 'leaf';
      let key = `${type}Id`;
      if (type === 'attr') key = 'attrName';
      let value = item.id;
      if (key === 'attrName') value = item.name;
      query[key] = value;
      if (item.children && item.children.length) {
        this.setDefaultQuery(item.children, query);
      }
    },
  },
  async created() {
    await this.getFirstNavList();
  },
};
</script>

<style scoped>
.menu{
  width: 300px;
  min-height: 1px;
}
</style>
